import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  [
    "relative",
    "inline-flex",
    "items-center",
    "justify-center",
    "transition-all",
    "duration-300",
    "cursor-pointer",
    "select-none",
    "whitespace-nowrap",
    "rounded-[var(--radius-lg)]",
    "focus-visible:outline-none",
    "disabled:pointer-events-none",
    "disabled:opacity-50",
  ],
  {
    variants: {
      variant: {
        primary: "rounded-full overflow-hidden",

        secondary: "rounded-full overflow-hidden",

        link: "bg-transparent text-neutral-700 gap-2",
        "link-plain": "bg-transparent text-neutral-700 gap-2",

        ghost: "bg-transparent",

        // Plain, non-animated rectangular buttons for dense admin/CRUD UI —
        // deliberately distinct from primary/secondary's pill + curtain
        // treatment, which is a marketing-site affordance that doesn't fit
        // an admin form.
        "admin-primary": "rounded-sm",

        "admin-secondary": "rounded-sm",
      },

      size: {
        sm: "h-auto text-[14px] leading-[20px] font-medium",
        md: "h-14 px-7",
        auto: "h-auto",
      },
    },

    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
);
